import ArrowRight from '../assets/arrow-right.svg';
import ArrowRightGold from '../assets/arrow-up.svg';
import BookIcon from '../assets/book.svg';
import People from '../assets/people.svg';
import Share from '../assets/share.svg';
import Shield from '../assets/shield-security.svg';
import WaitListLink from './WaitListLink';

function SectionSix() {
  const infiniteScrollContent = [
    {
      imgUrl: BookIcon,
      key: 1,
      headerText: 'Centralized Course Materials',
      content:
        'Gartekcloude offers a well-organized repository of course materials for all academic levels and fields of study, ensuring students can easily find and access what they need.',
    },

    {
      imgUrl: ArrowRightGold,
      key: 2,
      headerText: 'Personalized Learning Paths',
      content:
        'Our platform provides personalized study plans and recommendations, helping students optimize their learning based on their individual progress and needs.',
    },

    {
      imgUrl: People,
      key: 3,
      headerText: 'Vibrant Student Community',
      content:
        'Gartekcloude fosters a thriving academic community where students can connect, collaborate, and share knowledge, enhancing their Ed- experience through peer interaction.',
    },

    {
      imgUrl: Share,
      key: 4,
      headerText: 'Real-Time Collaboration Tools',
      content:
        'We offer powerful real-time collaboration features, including live document editing and project management, making group work and study sessions more efficient and productive.',
    },

    {
      imgUrl: Shield,
      key: 5,
      headerText: 'Enhanced Security and Privacy',
      content:
        'Gartekcloude prioritizes data security and privacy, utilizing robust encryption and security measures to protect user information and ensure a safe learning environment.',
    },
  ];
  const width = '350px';
  const height = '300px';
  const quantity = infiniteScrollContent.length;

  return (
    <section className="py-8 bg-black-variant text-white flex flex-col ap">
      <header className="flex justify-between items-center px-5">
        <h2 className="mb-4 text-3xl md:text-6xl font-extrabold">
          Why
          <br />
          <span className="text-gold">GartekCloude?</span>
        </h2>
        <WaitListLink
          childEl={
            <button
              type="button"
              className="hidden md:flex md:text-2xl rounded-full p-7 bg-gold font-extrabold"
            >
              <span className="flex flex-col gap-1 items-center">
                <span>
                  Join <br />
                  Wait List
                </span>
                <span className="icon-container icon-container-large">
                  <img src={ArrowRight} alt="" />
                </span>
              </span>
            </button>
          }
        />
      </header>

      <div
        className="w-full md:h-80 overflow-hidden slider"
        style={{
          '--width': width,
          '--quantity': quantity,
          '--height': height,
        }}
      >
        <div className="flex flex-col gap-8 px-6 py-12 w-full h-full list md:flex-row">
          {infiniteScrollContent.map((elementContent) => {
            const { key, content, headerText, imgUrl } = elementContent;
            return (
              <div
                key={key}
                className="flex flex-col  gap-5 border-4 rounded-2xl border-white px-4 py-6 item md:animate-autoRun"
                style={{
                  '--position': key,
                  animationDelay:
                    'calc((10s / var(--quantity)) * (var(--position) - 1) - 10s)',
                }}
              >
                <header className="feature-header">
                  <span className="bg-gold-opaque rounded-full p-6 w-20 h-20 flex flex-col justify-center items-center">
                    <span className="icon-container icon-container-large">
                      <img src={imgUrl} alt="" />
                    </span>
                  </span>
                </header>
                <div className="flex flex-col gap-2">
                  <h3 className="text-base font-bold">{headerText}</h3>
                  <p className="text-xs text-white-opaque-6">{content}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex flex-col items-center">
        <WaitListLink
          childEl={
            <button
              type="button"
              className="flex md:hidden text-lg rounded-full py-4 px-6 bg-gold font-extrabold"
            >
              <span className="flex flex-col gap-1 items-center">
                <span>
                  Join <br />
                  Wait List
                </span>
                <span className="icon-container icon-container-large">
                  <img src={ArrowRight} alt="" />
                </span>
              </span>
            </button>
          }
        />
      </div>
    </section>
  );
}

export default SectionSix;
